import { reactQueryGet } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { createQueryKeyFactory } from "@circle-react/lib/queries/createQueryKeyFactory";
import { queryClient } from "@circle-react/providers/QueryClient/reactQueryConfig";
import type { SpaceGroup } from "@circle-react/types";
import { queryOptions } from "react-query";

export const spaceGroupKey = createQueryKeyFactory("space-group");

export interface SpaceGroupsApiResponse {
  records: SpaceGroup[];
}

export const spaceGroupQueries = {
  list: () =>
    queryOptions({
      queryKey: spaceGroupKey.key("list"),
      queryFn: () =>
        reactQueryGet<SpaceGroupsApiResponse>(internalApi.spaceGroups.index()),
    }),
  detail: (id: string | number) =>
    queryOptions({
      queryKey: spaceGroupKey.key("detail", id),
      queryFn: () =>
        reactQueryGet<SpaceGroup>(internalApi.spaceGroups.show({ id })),
    }),
  disabledDetail: () =>
    queryOptions({
      queryKey: spaceGroupKey.key("detail", "disabled"),
      queryFn: () => Promise.reject(new Error("spaceGroupId is required")),
      enabled: false,
    }),
  resourceDetail: (id?: number) =>
    queryOptions({
      queryKey: id
        ? spaceGroupKey.key("detail", id)
        : spaceGroupKey.key("detail", "disabled"),
      queryFn: () => {
        if (!id) {
          return Promise.reject(new Error("spaceGroupId is required"));
        }

        return reactQueryGet<SpaceGroup>(internalApi.spaceGroups.show({ id }));
      },
      enabled: Boolean(id),
    }),
  includeDeletedList: () =>
    queryOptions({
      queryKey: spaceGroupKey.key("include-deleted", "list"),
      queryFn: () =>
        reactQueryGet<SpaceGroupsApiResponse>(
          internalApi.spaceGroups.index({ include_deleted: "true" }),
        ),
    }),
};

export const spaceGroupInvalidations = {
  all: () => queryClient.invalidateQueries({ queryKey: spaceGroupKey.root() }),
};
